import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Noimg from "../images/no_img.jpg";
import { getProduct, orderStatus } from "api/ProductApi";
import { currentRegister, filterFormatToDate } from "utility/Constant.js";
import ProductCommon from "../components/ProductLike&Wish";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { getBranchId } from "utility/HeaderConfig";
import { getPageProductType } from "api/ProductTypeApi";
import { getAllProductSubCate } from "api/ProductSubCateApi";
import { getAllProductCate } from "api/ProductCategoryApi";
import { genderBasedIcons } from "components/GenderBasedIcons";
import no_data from "images/no_data.png";
// import SkeletonLoader from "components/SkeletonLoader";
import { dayClose } from "../api/NewSchemeApi";
import moment from "moment";
import SEO from "components/headers/Seo";

const PRICE_PRESETS = [
  { label: "Under ₹10,000", min: 0, max: 10000 },
  { label: "₹10,001 - ₹20,000", min: 10001, max: 20000 },
  { label: "₹20,001 - ₹50,000", min: 20001, max: 50000 },
  { label: "₹50,001 - ₹1,00,000", min: 50001, max: 100000 },
  { label: "Above ₹1,00,000", min: 100001, max: 1000000 },
];
const PRICE_MIN = 0;
const PRICE_MAX = 500000;

const Chevron = ({ open }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    className={`pl-filter-chevron${open ? " open" : ""}`}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

function FilterSection({ title, defaultOpen = true, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="pl-filter-section">
      <button className="pl-filter-head" onClick={() => setOpen((v) => !v)}>
        <span className="pl-filter-head-label">{title}</span>
        <Chevron open={open} />
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="body"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.22 }}
            style={{ overflow: "hidden" }}
          >
            <div className="pl-filter-body">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

function SidebarContent({
  productType,
  productCategory,
  productSubCate,
  selectedList,
  setSelectedList,
  priceRange,
  setPriceRange,
  pricePreset,
  setPricePreset,
  grossWeightFrom,
  grossWeightTo,
  setGrossWeightFrom,
  setGrossWeightTo,
  resetAll,
}) {
  const hasFilter =
    selectedList.type ||
    selectedList.category ||
    selectedList.subCategory ||
    selectedList.gender ||
    pricePreset !== null ||
    priceRange[0] > PRICE_MIN ||
    priceRange[1] < PRICE_MAX ||
    grossWeightFrom !== "" ||
    grossWeightTo !== "";

  const handlePreset = (preset, idx) => {
    if (pricePreset === idx) {
      setPricePreset(null);
      setPriceRange([PRICE_MIN, PRICE_MAX]);
    } else {
      setPricePreset(idx);
      setPriceRange([preset.min, preset.max]);
    }
  };

  return (
    <>
      <div className="pl-sidebar-header">
        <span className="pl-sidebar-title">Filters</span>
        {hasFilter && (
          <button
            className="pl-clear-all"
            style={{ textDecoration: "none" }}
            onClick={resetAll}
          >
            CLEAR ALL
          </button>
        )}
      </div>

      <FilterSection title="Metal Type">
        {productType.map((d) => {
          const active = selectedList.type === d.id;
          return (
            <button
              key={d.id}
              className="pl-opt"
              onClick={() =>
                setSelectedList((p) =>
                  active
                    ? {
                        ...p,
                        type: "",
                        typeName: "",
                        category: "",
                        categoryName: "",
                        subCategory: "",
                        subCategoryName: "",
                      }
                    : {
                        ...p,
                        type: d.id,
                        typeName: d.name,
                        category: "",
                        categoryName: "",
                        subCategory: "",
                        subCategoryName: "",
                      },
                )
              }
            >
              <span className={`pl-opt-check${active ? " checked" : ""}`}>
                {active && (
                  <svg
                    width="9"
                    height="9"
                    viewBox="0 0 12 12"
                    fill="none"
                    stroke="white"
                    strokeWidth="2.5"
                  >
                    <polyline points="2 6 5 9 10 3" />
                  </svg>
                )}
              </span>
              <span className="pl-opt-label">{d.name}</span>
            </button>
          );
        })}
      </FilterSection>

      <FilterSection title="Price">
        <div className="pl-price-range">
          <div className="pl-price-presets">
            {PRICE_PRESETS.map((p, i) => (
              <button
                key={i}
                className="pl-price-preset"
                onClick={() => handlePreset(p, i)}
              >
                <span
                  className={`pl-opt-check${pricePreset === i ? " checked" : ""}`}
                >
                  {pricePreset === i && (
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 12 12"
                      fill="none"
                      stroke="white"
                      strokeWidth="2.5"
                    >
                      <polyline points="2 6 5 9 10 3" />
                    </svg>
                  )}
                </span>
                <span className="pl-opt-label mx-2">{p.label}</span>
              </button>
            ))}
          </div>
        </div>
      </FilterSection>

      <FilterSection title="Gross Weight (g)" defaultOpen={false}>
        <div className="pl-grossweight-row">
          <input
            type="number"
            min="0"
            inputMode="decimal"
            placeholder="Min"
            className="pl-grossweight-input"
            value={grossWeightFrom}
            onChange={(e) => {
              const v = e.target.value;
              if (v === "" || Number(v) >= 0) setGrossWeightFrom(v);
            }}
          />
          <span className="pl-grossweight-sep">–</span>
          <input
            type="number"
            min="0"
            inputMode="decimal"
            placeholder="Max"
            className="pl-grossweight-input"
            value={grossWeightTo}
            onChange={(e) => {
              const v = e.target.value;
              if (v === "" || Number(v) >= 0) setGrossWeightTo(v);
            }}
          />
        </div>
      </FilterSection>

      <FilterSection title="Category" defaultOpen={true}>
        {productCategory.map((d) => {
          const active = selectedList.category === d.id;
          return (
            <button
              key={d.id}
              className="pl-opt"
              onClick={() =>
                setSelectedList((p) =>
                  active
                    ? {
                        ...p,
                        category: "",
                        categoryName: "",
                        subCategory: "",
                        subCategoryName: "",
                      }
                    : {
                        ...p,
                        category: d.id,
                        categoryName: d.categoryName,
                        subCategory: "",
                        subCategoryName: "",
                      },
                )
              }
            >
              <span className={`pl-opt-check${active ? " checked" : ""}`}>
                {active && (
                  <svg
                    width="9"
                    height="9"
                    viewBox="0 0 12 12"
                    fill="none"
                    stroke="white"
                    strokeWidth="2.5"
                  >
                    <polyline points="2 6 5 9 10 3" />
                  </svg>
                )}
              </span>
              <span className="pl-opt-label">{d.categoryName}</span>
            </button>
          );
        })}
      </FilterSection>

      {productSubCate.length > 0 && (
        <FilterSection title="Sub Category" defaultOpen={false}>
          {productSubCate.map((d) => {
            const active = selectedList.subCategory === d.id;
            return (
              <button
                key={d.id}
                className="pl-opt"
                onClick={() =>
                  setSelectedList((p) =>
                    active
                      ? { ...p, subCategory: "", subCategoryName: "" }
                      : {
                          ...p,
                          subCategory: d.id,
                          subCategoryName: d.subCategoryName,
                        },
                  )
                }
              >
                <span className={`pl-opt-check${active ? " checked" : ""}`}>
                  {active && (
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 12 12"
                      fill="none"
                      stroke="white"
                      strokeWidth="2.5"
                    >
                      <polyline points="2 6 5 9 10 3" />
                    </svg>
                  )}
                </span>
                <span className="pl-opt-label">{d.subCategoryName}</span>
              </button>
            );
          })}
        </FilterSection>
      )}

      <FilterSection title="GENDER" defaultOpen={false}>
        <div className="pl-gender-grid">
          {[{ gender: "A", title: "All" }, ...genderBasedIcons].map((d) => (
            <button
              key={d.gender}
              className={`pl-gender-opt${selectedList.gender === d.gender ? " active" : ""}`}
              onClick={() =>
                setSelectedList((p) =>
                  p.gender === d.gender
                    ? { ...p, gender: "", genderName: "" }
                    : { ...p, gender: d.gender, genderName: d.title },
                )
              }
            >
              <span style={{ fontSize: 18 }}>{d.icon}</span>
              <span>{d.title}</span>
            </button>
          ))}
        </div>
      </FilterSection>
    </>
  );
}

export default function ProductList({ configImages }) {
  const location = useLocation();
  const myparam = location.state;
  const history = useNavigate();

  const [banner, setBanner] = useState([]); // eslint-disable-line
  const [loading, setLoading] = useState(true);
  const [listLoading, setListLoading] = useState(true); // eslint-disable-line
  const [size, setSize] = useState(21);
  const [productType, setProductType] = useState([]);
  const [productSubCate, setProductSubCate] = useState([]);
  const [productCategory, setCategoryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [dayClosedDates, setDayClosedDates] = useState(""); // eslint-disable-line
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [hoveredIdx, setHoveredIdx] = useState(null); // eslint-disable-line
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  const [sortBy, setSortBy] = useState("default");
  const [allSubCate, setAllSubCate] = useState([]); // eslint-disable-line
  const [priceRange, setPriceRange] = useState([PRICE_MIN, PRICE_MAX]);
  const [pricePreset, setPricePreset] = useState(null);
  const [grossWeightFrom, setGrossWeightFrom] = useState("");
  const [grossWeightTo, setGrossWeightTo] = useState("");
  const [totalCount,setTotalCount] = useState(0);

  const [selectedList, setSelectedList] = useState({
    type: "",
    category: "",
    subCategory: "",
    gender: "",
    typeName: "",
    categoryName: "",
    subCategoryName: "",
    genderName: "",
  });
  // const [lists] = useState(["gold", "silver", "diamond", "platinum"]); // eslint-disable-line

  useEffect(() => {
    getProductType();
    setSelectedList((prev) => ({
      ...prev,
      type: myparam?.type
        ? myparam.type.id
        : myparam?.cat?.metaProdTypeId || "",
      category: myparam?.category
        ? myparam.category.id
        : myparam?.cat?.metaProdCateId || "",
      typeName: myparam?.type
        ? myparam.type.name
        : myparam?.cat?.metaProdType || "",
      categoryName: myparam?.category
        ? myparam.category.categoryName
        : myparam?.cat?.metaProdCateName || "",
      subCategory: myparam?.cat?.id || "",
      subCategoryName: myparam?.cat?.subCategoryName || "",
      genderName: "",
    }));
    //eslint-disable-next-line
  }, [myparam]);

  useEffect(() => {
    getCategoryList();
    getProductSub();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    Promise.all([
      orderStatus({ orderStatusName: "sale" }).then((d) => d.response?.[0].id),
      orderStatus({ orderStatusName: "Transferred" }).then(
        (d) => d.response?.[0].id,
      ),
      orderStatus({ orderStatusName: "Sold" }).then((d) => d.response?.[0].id),
    ]).then(([sale, transfer, sold]) => {
      // PRIORITY 1: Subcategory navigation (from CategorysMenu dropdown)
      if (myparam?.cat) {
        getProducts(sale, transfer, sold);
        setSelectedList((prev) => ({
          ...prev,
          subCategory: myparam.cat?.id,
          subCategoryName: myparam.cat?.subCategoryName,
          category: myparam.cat?.metaProdCateId,
          categoryName: myparam.cat?.metaProdCateName || "",
          type: myparam.cat?.metaProdTypeId,
          typeName: myparam.cat?.metaProdType || "",
        }));
      }
      // PRIORITY 2: Both type and category
      else if (myparam?.type && myparam?.category) {
        setSelectedList((prev) => ({
          ...prev,
          type: myparam.type.id,
          typeName: myparam.type.name,
          category: myparam.category.id,
          categoryName: myparam.category.categoryName,
          subCategory: "",
          subCategoryName: "",
          genderName: "",
        }));
      }
      // PRIORITY 3: Only category
      else if (myparam?.category) {
        getProducts(sale, transfer, sold);
        setSelectedList((prev) => ({
          ...prev,
          type: myparam.category.metaProdTypeId || "",
          category: myparam.category.id,
          typeName: myparam.category.metaProdType || "",
          categoryName: myparam.category.categoryName,
          subCategory: "",
          subCategoryName: "",
          genderName: "",
        }));
      }
      // PRIORITY 4: Only type
      else if (myparam?.type) {
        setSelectedList((prev) => ({
          ...prev,
          type: myparam.type.id,
          category: "",
          typeName: myparam.type.name,
          categoryName: "",
          subCategory: "",
          subCategoryName: "",
          genderName: "",
        }));
      }
      // PRIORITY 5: URL query parameters (when opening shared link in new tab)
      else {
        const { search } = location;
        const params = new URLSearchParams(search);
        const productFilters = Object.fromEntries(
          [...params.entries()]?.map(([key, value]) => [
            key,
            isNaN(value) ? value : Number(value),
          ]),
        );

        // Only apply URL params if there are any
        if (Object.keys(productFilters)?.length > 0) {
          setSelectedList((prev) => ({
            ...prev,
            ...productFilters,
          }));
          // Filtered fetch is handled by the useEffect watching selectedList
        } else {
          // No filters from anywhere, show all products
          getProducts(sale, transfer, sold);
        }
      }
      setOrderStatusList([sale, transfer, sold]);
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (orderStatusList?.length === 0) return;
    if (dayClosedDates !== "") {
      getProductList(dayClosedDates);
    } else {
      dayClose({ module: "Sales" }).then((data) => {
        if (data.response?.length > 0) {
          const dc = moment(
            data.response?.[0]?.activeDate,
            "MMM DD, YYYY, h:mm:ss A",
          ).format("YYYY-MM-DD");
          setDayClosedDates(dc);
          getProductList(dc);
        }
      });
    }
    //eslint-disable-next-line
  }, [selectedList, size, priceRange, grossWeightFrom, grossWeightTo]);

  const getProducts = (sale, transfer, sold) => {
    getProduct(size, {
      allowCatalogue: 1,
      branch: getBranchId(),
      beforeCreatedAt: currentRegister(),
      demoStatus: "Demo_Completed,Demo_Cancelled,Available_For_Demo",
      metaProdCateEnty: myparam?.category?.id,
      metaProdTypeEnty: myparam?.category?.metaProdTypeId || "",
      removeHp: "HP-",
      removeNTP: "NTP-",
      sortType: true,
      statusId: `${sale}, ${transfer}, ${sold}`,
      sort: "asc",
    }).then((data) => {
      let products;
      if (data.response && typeof data.response === "string") {
        try {
          const sanitizedResponse = data.response.replace(/\bNaN\b/g, "null");
          products = JSON.parse(sanitizedResponse);
        } catch (parseError) {
          console.error("Failed to parse response:", parseError);
          products = { content: [], totalCount: 0 };
        }
      } else {
        products = data.response || { content: [], totalCount: 0 };
      }
      setProductList(products.content);
      setTotalCount(products.totalCount)
      setLoading(false);
    });
  };

  const getProductType = () => {
    setListLoading(true);
    getPageProductType({ active: 1 }).then((d) => {
      const list = d.response.content.filter(
        (x) => x.metaProductCategoryList?.length > 0 && x.id,
      );
      setProductType([...list].reverse());
      setListLoading(false);
    });
  };

  const getCategoryList = () => {
    setListLoading(true);
    getAllProductCate({}).then((d) => {
      setCategoryList(
        d.response.filter(
          (i) =>
            i.visibilityMode === "WEB_MOBILE" || i.visibilityMode === "MOBILE",
        ),
      );
      setListLoading(false);
    });
  };

  const getProductSub = () => {
    getAllProductSubCate({}).then((d) => {
      setAllSubCate(d.response);
      setProductSubCate(d.response);
      setListLoading(false);
    });
  };

  useEffect(() => {
    if (selectedList.category) {
      const selectedCat = productCategory.find(
        (c) => c.id === selectedList.category,
      );

      if (selectedCat?.metaProdSubCateKeyMap) {
        const mappedProd = Object.entries(
          selectedCat.metaProdSubCateKeyMap,
        ).map(([id, name]) => ({ id, subCategoryName: name }));
        setProductSubCate(mappedProd);
      } else {
        setProductSubCate([]);
      }
    } else {
      const all = productCategory.flatMap((cat) =>
        cat.metaProdSubCateKeyMap
          ? Object.entries(cat.metaProdSubCateKeyMap).map(([id, name]) => ({
              id,
              subCategoryName: name,
            }))
          : [],
      );
      setProductSubCate(all);
    }
  }, [selectedList.category, productCategory, location.key]);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   const text = e.nativeEvent.target[e.nativeEvent.target.selectedIndex]?.text;
  //   if (name === "type") setSelectedList((p) => ({ ...p, type: value, typeName: text, category: "", categoryName: "", subCategory: "", subCategoryName: "" }));
  //   else if (name === "category") setSelectedList((p) => ({ ...p, category: value, categoryName: text, subCategory: "", subCategoryName: "" }));
  //   else if (name === "subCategory") setSelectedList((p) => ({ ...p, subCategory: value, subCategoryName: text }));
  //   else if (name === "gender") setSelectedList((p) => ({ ...p, gender: value, genderName: text }));
  // };

  const getProductList = (dayCloseDate) => {
    setLoading(true);
    const [sale, delivered, sold] = orderStatusList;
    if (!sale || !delivered || !sold) return;
    const filterData = {
      removeNTP: "NTP-",
      removeHP: "HP-",
      beforeCreatedAt: filterFormatToDate(dayCloseDate),
      branch: getBranchId(),
      ...(selectedList.type && { metaProdTypeEnty: selectedList.type }),
      ...(selectedList.category && { metaProdCateEnty: selectedList.category }),
      ...(selectedList.subCategory && {
        productSubcategory: selectedList.subCategory,
      }),
      ...(selectedList.gender && { userType: selectedList.gender }),
      ...(priceRange?.[0] > PRICE_MIN && { minPrice: priceRange?.[0] }),
      ...(priceRange?.[1] < PRICE_MAX && { maxPrice: priceRange?.[1] }),
      ...(grossWeightFrom !== "" && { grossWeightFrom: Number(grossWeightFrom) }),
      ...(grossWeightTo !== "" && { grossWeightTo: Number(grossWeightTo) }),
      statusId: `${sale},${delivered},${sold}`,
      allowCatalogue: 1,
      productDemoStatus: "Available_For_Demo,Demo_Completed,Demo_Cancelled",
    };
    getProduct(size, filterData)
      .then((data) => {
        let products;
      if (data.response && typeof data.response === "string") {
        try {
          const sanitizedResponse = data.response.replace(/\bNaN\b/g, "null");
          products = JSON.parse(sanitizedResponse);
        } catch (parseError) {
          console.error("Failed to parse response:", parseError);
          products = { content: [], totalCount: 0 };
        }
      } else {
        products = data.response || { content: [], totalCount: 0 };
      }
        setProductList(products.content);
        setTotalCount(products.totalCount)
        setLoading(false);
      })
      .catch(console.log);
  };

  const resetAll = () => {
    setSelectedList({
      type: "",
      category: "",
      subCategory: "",
      gender: "",
      typeName: "",
      categoryName: "",
      subCategoryName: "",
      genderName: "",
    });
    setPriceRange([PRICE_MIN, PRICE_MAX]);
    setPricePreset(null);
    setGrossWeightFrom("");
    setGrossWeightTo("");
  };

  useEffect(() => {
    configImages?.E_COMMERCE_BANNERS?.forEach((d) => {
      if (d.key === "productList") setBanner(d.value);
    });
    //eslint-disable-next-line
  }, []);

  const imgSrc = (item) =>
    item.images === "@#@" || !item.images ? Noimg : item.images.split("@#@")[0];
  // const hasFilter = selectedList.type || selectedList.category || selectedList.subCategory || selectedList.gender;
  const filteredList = productList.filter((item) => {
    const price = Number(item.total) || 0;
    return price >= priceRange[0] && price <= priceRange[1];
  });

  const sortedList = [...filteredList].sort((a, b) => {
    const priceA = Number(a.total) || 0;
    const priceB = Number(b.total) || 0;
    if (sortBy === "price_asc") return priceA - priceB;
    if (sortBy === "price_desc") return priceB - priceA;
    if (sortBy === "name_asc")
      return (a.title || "").localeCompare(b.title || "");
    return 0;
  });

  const activeFilters = [
    selectedList.typeName && {
      label: selectedList.typeName,
      clear: () => setSelectedList((p) => ({ ...p, type: "", typeName: "" })),
    },
    selectedList.categoryName && {
      label: selectedList.categoryName,
      clear: () =>
        setSelectedList((p) => ({ ...p, category: "", categoryName: "" })),
    },
    selectedList.subCategoryName && {
      label: selectedList.subCategoryName,
      clear: () =>
        setSelectedList((p) => ({
          ...p,
          subCategory: "",
          subCategoryName: "",
        })),
    },
    selectedList.genderName && {
      label: selectedList.genderName,
      clear: () =>
        setSelectedList((p) => ({ ...p, gender: "", genderName: "" })),
    },
    pricePreset !== null && {
      label: PRICE_PRESETS[pricePreset]?.label,
      clear: () => {
        setPricePreset(null);
        setPriceRange([PRICE_MIN, PRICE_MAX]);
      },
    },
    (grossWeightFrom !== "" || grossWeightTo !== "") && {
      label: `Gross Wt: ${grossWeightFrom || "0"}g - ${grossWeightTo || "∞"}g`,
      clear: () => {
        setGrossWeightFrom("");
        setGrossWeightTo("");
      },
    },
  ].filter(Boolean);

  const sidebarProps = {
    productType,
    productCategory,
    productSubCate,
    selectedList,
    setSelectedList,
    priceRange,
    setPriceRange,
    pricePreset,
    setPricePreset,
    grossWeightFrom,
    grossWeightTo,
    setGrossWeightFrom,
    setGrossWeightTo,
    resetAll,
  };

  return (
    <div className="pl-shell">
      <SEO
        title="Products — AVM Jewellers"
        description="Browse our jewellery collection."
        name="AVM Jewellers"
        type="article"
      />

      {/* Banner */}
      {/* {banner?.length > 0
        ? <img src={banner} alt="Products" className="pl-banner" />
        : <Skeleton style={{ height: 180, width: "100%", display: "block" }} />
      } */}

      {/* Breadcrumb */}
      {/* <div style={{ background: "var(--surface-cream)" }}>
        <div className="container"> 
          <nav style={{ display: "flex", alignItems: "center", gap: 8, paddingTop: "14px", fontSize: 10, color: "var(--ink-400)" }}> */}
      <div
        className="ptSans px-sm-5 pt-2 px-5"
        tw="text-sm pt-3"
        style={{ background: "var(--surface-cream)", height: "70px" }}
      >
        <div
          tw="ml-3 text-custom-100 capitalize tracking-wide"
          className="mb-1"
          style={{
            color: "var(--ink-700)",
            fontWeight: 500,
            fontSize: "14px",
            textTransform: "capitalize",
          }}
        >
          JEWELLERY
          <span style={{ fontWeight: 250, fontSize: "10px" }} className="mx-2">
              <>
                <strong>{totalCount}</strong> Products
              </>
          </span>
        </div>
        <Link
          to="/"
          className="mx-1"
          tw="mx-3 no-underline"
          style={{
            color: "var(--ink-700)",
            textDecoration: "none",
            fontWeight: 350,
            fontSize: "10px",
          }}
        >
          HOME
        </Link>
        {">"}
        <Link
          to="/ProductList"
          className="mx-1"
          tw="mx-3 no-underline"
          style={{
            color: "var(--ink-700)",
            textDecoration: "none",
            fontWeight: 350,
            fontSize: "10px",
            textTransform: "uppercase",
          }}
        >
          {selectedList.typeName || selectedList.category || "PRODUCTS"}
        </Link>
        {/* </nav>
        </div> */}
      </div>

      {/* {activeFilters.length > 0 && (
        <div className="container">
          <div className="pl-chips mt-3" style={{ paddingBottom: 12 }}>
            <span style={{ fontSize: 12, color: "var(--#643f6bd)", fontWeight: 600, alignSelf: "center" }}>Filters:</span>
            {activeFilters.map((f, i) => (
              <span key={i} className="pl-chip">
                {f.label}
                <button className="pl-chip-x" onClick={f.clear}>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                    strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              </span>
            ))}
          </div>
        </div>
      )} */}

      <div className="pl-body">
        <aside className="pl-sidebar">
          <SidebarContent {...sidebarProps} />
        </aside>

        <main className="pl-content">
          <div className="pl-toolbar">
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <button
                className="pl-mobile-filter-btn"
                onClick={() => setMobileFilterOpen(true)}
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                </svg>
                Filters
                {activeFilters?.length > 0 && (
                  <span
                    style={{
                      background: "#4f3267",
                      color: "#fff",
                      borderRadius: "50%",
                      width: 18,
                      height: 18,
                      fontSize: 10,
                      fontWeight: 700,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {activeFilters?.length}
                  </span>
                )}
              </button>
              {/* <p className="pl-result-count">
                {loading ? "Loading…" : <><strong>{sortedList.length}</strong> products found</>}
              </p> */}
              {activeFilters?.length > 0 && (
                <div className="container">
                  <div className="pl-chips">
                    {/* <span style={{ fontSize: 12, color: "var(--#643f6bd)", fontWeight: 600, alignSelf: "center" }}>Filters:</span> */}
                    {activeFilters?.map((f, i) => (
                      <span key={i} className="pl-chip">
                        {f.label}
                        <button className="pl-chip-x" onClick={f.clear}>
                          <svg
                            width="11"
                            height="11"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                          >
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                          </svg>
                        </button>
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className="pl-sort-wrap">
              <span className="pl-sort-label">Sort by:</span>
              <select
                className="pl-sort-select"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="default">Featured</option>
                <option value="price_asc">Price: Low to High</option>
                <option value="price_desc">Price: High to Low</option>
                <option value="name_asc">Name: A - Z</option>
              </select>
            </div>
          </div>

          {/* Grid */}
          {loading ? (
            <div className="pl-grid">
              {Array.from({ length: 9 }).map((_, i) => (
                <div key={i} className="pl-skel-card">
                  <Skeleton style={{ height: 220 }} />
                  <div style={{ padding: 14 }}>
                    <Skeleton
                      height={10}
                      style={{ marginBottom: 6, borderRadius: 4 }}
                    />
                    <Skeleton
                      height={13}
                      style={{ marginBottom: 8, borderRadius: 4 }}
                    />
                    <Skeleton
                      height={17}
                      width="40%"
                      style={{ borderRadius: 4 }}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : sortedList?.length === 0 ? (
            <div className="pl-empty">
              <img src={no_data} alt="No products" />
              <p>No products found. Try adjusting your filters.</p>
            </div>
          ) : (
            <>
              <div className="pl-grid">
                {sortedList?.map((item, i) => (
                  <motion.div
                    key={item.id || i}
                    className="pl-card"
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      duration: 0.28,
                      delay: Math.min(i * 0.03, 0.4),
                    }}
                    onMouseEnter={() => setHoveredIdx(i)}
                    onMouseLeave={() => setHoveredIdx(null)}
                    onClick={() =>
                      history(`/ProductDetails/${item.id}`, {
                        state: { categoryItem: item },
                      })
                    }
                  >
                    {/* Like/Wish */}
                    <div
                      className="pl-card-actions"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <ProductCommon categoryItem={item} />
                    </div>

                    {/* Badge */}
                    {item.stockStatus === "Sale" ? (
                      <span className="pl-card-badge">Available</span>
                    ) : <span className="pl-card-soldbadge">Sold</span>}

                    {/* Image */}
                    <div className="pl-card-img-wrap">
                      <img
                        className="pl-card-img"
                        src={imgSrc(item)}
                        alt={item.title || "Product"}
                        loading="lazy"
                      />
                    </div>

                    {/* Info */}
                    <div className="pl-card-body">
                      <p className="pl-card-metal">{item.metalType}</p>
                      <p className="pl-card-title" title={item.title}>
                        {item.title}
                      </p>
                      <div className="pl-card-footer">
                        <span className="pl-card-price">
                          ₹{Math.trunc(item.total).toLocaleString("en-IN")}
                        </span>
                        {item.goldPurity && item.goldPurity !== "-" && (
                          <span className="pl-card-purity">
                            {item.goldPurity}
                          </span>
                        )}
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* Load more */}
              <div className="pl-loadmore">
                <button
                  className="pl-loadmore-btn"
                  onClick={() => setSize((s) => s + 21)}
                >
                  Load More
                </button>
              </div>
            </>
          )}
        </main>
      </div>

      {/* ── Mobile filter drawer ── */}
      <div
        className={`pl-drawer-overlay${mobileFilterOpen ? " open" : ""}`}
        onClick={() => setMobileFilterOpen(false)}
      />
      <div className={`pl-drawer${mobileFilterOpen ? " open" : ""}`}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 16,
          }}
        >
          <span
            style={{
              fontWeight: 800,
              fontSize: 14,
              letterSpacing: ".06em",
              textTransform: "uppercase",
              color: "#13081a",
            }}
          >
            Filters
          </span>
          <button
            onClick={() => setMobileFilterOpen(false)}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "var(--#643f6bd)",
              padding: 4,
            }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <SidebarContent {...sidebarProps} />
        <div style={{ marginTop: 20 }}>
          <button
            className="pl-loadmore-btn"
            style={{ width: "100%" }}
            onClick={() => setMobileFilterOpen(false)}
          >
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  );
}